import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { type Config } from '../../models';
import { initSentry } from '../../sentry';
import { getConfig } from '../../services';

// https://ce-integration.biosecurity.np.cp1.agriculture.gov.au/config/config.json
const defaultConfig: Config = {
  ENDPOINT: 'http://localhost/dev',
  SITEKEY: '6LcF3iMUAAAAAJVwbf2xQ05Xy5U4cI__NoXdTyQn',
};

const ConfigContext = React.createContext(defaultConfig);

type Props = React.PropsWithChildren<object>;

export const ConfigProvider = ({ children }: Props) => {
  const { data, status, error } = useQuery({
    queryKey: ['getConfig'],
    queryFn: getConfig,
  });

  useEffect(() => {
    if (status === 'success') {
      initSentry(data);
    } else if (status === 'error') {
      console.error('Failed to initialize Sentry:', error);
    }
  }, [status, data, error]);

  switch (status) {
    case 'success':
    case 'error':
      return (
        <ConfigContext.Provider value={data ?? defaultConfig}>{children}</ConfigContext.Provider>
      );
    default:
      return null;
  }
};

export default ConfigContext;
